import { render, staticRenderFns } from "./detailHistoricNews.vue?vue&type=template&id=f9f2fa34&scoped=true&"
import script from "./detailHistoricNews.vue?vue&type=script&lang=js&"
export * from "./detailHistoricNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f2fa34",
  null
  
)

export default component.exports